import React from 'react';
import { FaSearchPlus, FaHandPaper, FaHome } from 'react-icons/fa';
import './ZoomBar.css';

const ZoomBar = ({ 
  zoomLevel, 
  onResetZoom, 
  isPanMode, 
  onTogglePan,
  isZoomMode,
  onToggleZoom
}) => {
  return (
    <div className="zoom-bar">
      <div className="zoom-controls">
        <button 
          className={`zoom-btn ${isZoomMode ? 'active' : ''}`}
          onClick={onToggleZoom}
          title="Zoom Tool (Z) - Scroll to zoom at cursor"
        >
          <FaSearchPlus />
        </button>
        
        <button 
          className={`zoom-btn ${isPanMode ? 'active' : ''}`}
          onClick={onTogglePan}
          title="Pan Tool (Space) - Drag to pan"
        >
          <FaHandPaper />
        </button>
        
        <span className="zoom-level">
          {Math.round(zoomLevel * 100)}%
        </span>
        
        <button 
          className="zoom-btn"
          onClick={onResetZoom}
          title="Reset Zoom (0)"
        >
          <FaHome />
        </button>
      </div>
    </div>
  );
};

export default ZoomBar;
